var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V28H14.9567V17.1578H11.3089V12.9344H14.9567V9.82333C14.9567 6.20667 17.1656 4.23889 20.4011 4.23889C21.4895 4.23736 22.5772 4.29187 23.66 4.40222V8.18222H21.4122C19.6622 8.18222 19.32 9.01444 19.32 10.2433V12.9422H23.5044L22.96 17.1656H19.32V28H28V0H0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5b6c95e0ecbf6654e73d5da0b62647a4.svg";
export { ForwardRef as ReactComponent };